// Role names as used by availableRoles (mapped from numeric IDs via config.roles Map).
// Priority order: most-privileged first. When no saved role is available, the app
// falls back to the highest-privilege role the user actually has.
export const ROLE_PRIORITY = ['advert-admin', 'admin', 'manager', 'ad-exchange'] as const;

/**
 * Pick the preferred role from a list of available role names.
 * Returns the highest-priority match from ROLE_PRIORITY, or the first element
 * when none of the priority roles are present.
 * Returns null for an empty list.
 */
export const pickPreferredRole = (available: ReadonlyArray<string>): string | null => {
  if (available.length === 0) {
    return null;
  }
  for (const r of ROLE_PRIORITY) {
    if (available.includes(r)) {
      return r;
    }
  }
  return available[0] ?? null;
};

/**
 * Build a URL that opens the current page with the given role pre-applied via
 * the `?role=` query param. Preserves existing query params and hash.
 * Middle-clicking or Cmd+clicking an anchor with this href opens the page in a
 * new tab where initializeApp reads the param and activates the role immediately.
 */
export const buildRoleSwitchHref = (role: string): string => {
  const params = new URLSearchParams(window.location.search);
  params.set('role', role);
  return `${window.location.pathname}?${params.toString()}${window.location.hash}`;
};
